import * as React from 'react';
import Fab, { FabProps } from '@material-ui/core/Fab';

export type DSFabProps = FabProps;

export const DSFab: React.FC<DSFabProps> = props => <Fab {...props} />;
DSFab.displayName = 'DSFab';
